import { memo } from "react";
import { Button } from "../../../../../Button";
import { useTableContext } from "../../../../context";

export const ResetFilter = memo(() => {
  const table = useTableContext();

  return (
    <Button
      buttonSize="md"
      buttonType="tertiaryGray"
      onClick={(event) =>
        table?.resetColumnFilters(event.getModifierState("Shift").valueOf())
      }
    >
      Reset filters
    </Button>
  );
});